// ApiUtils.js - Updated to support multiple tokens

// Base URLs
export const baseUrl = `/api/`; // Original base URL for same-origin APIs
export const optionsApiUrl = `${window.APP_CONFIG?.optionsApiUrl}`; // New Options API URL

// Updated to build headers for EPIIC API (default API)
export function buildHeaders() {
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${sessionStorage
      .getItem("accessToken")
      .substring(1, sessionStorage.getItem("accessToken").length - 1)}`, // remove surrounding ""
  };
}
 
// New function for Options API headers
export function buildOptionsApiHeaders() {
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${sessionStorage
      .getItem("optionsApiToken")
      .substring(1, sessionStorage.getItem("optionsApiToken").length - 1)}`, // remove surrounding ""
  };
}

// Original API utilities for same-origin requests - unchanged
export function GetHeaders(additionalHeaders = {}) {
  return { method: "GET", headers: { ...buildHeaders(), ...additionalHeaders } };
}

export function PostOptions(body, additionalHeaders = {}) {
  return {
    method: "POST",
    headers: { ...buildHeaders(), ...additionalHeaders },
    body: JSON.stringify(body),
  };
}

export function PutOptions(body, additionalHeaders = {}) {
  return {
    method: "POST",
    headers: { ...buildHeaders(), ...additionalHeaders },
    body: JSON.stringify(body),
  };
}

export function DeleteHeaders(additionalHeaders = {}) {
  return { method: "POST", headers: { ...buildHeaders(), ...additionalHeaders } };
}

// Response handling - unchanged
export async function handleResponse(response) {
  if (response.ok) {
    let jsonResp = response.json();
    return jsonResp;
  }
  if (response.status === 400) {
    const error = await response.text();
    throw new Error(error);
  }
  var err = await response.text();
  throw new Error(response.status + " " + err);
}

export function handleError(error) {
  console.error("API call failed. " + error);
  throw error;
}

// Options API specific functions - UPDATED to use the OPTIONS token
export async function fetchFromOptionsApi(endpoint) {
  try {
    // Get Options API token from session storage
    const token = sessionStorage
      .getItem("optionsApiToken") // Changed to use the optionsApiToken
      .substring(1, sessionStorage.getItem("optionsApiToken").length - 1);
    
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    };
    
    const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
    console.log(`Running in ${env} environment`);
    console.log(`API URL: ${process.env.OPTIONS_API_URL}`);
    console.log("get endpoint:", `${optionsApiUrl}/${endpoint}`);

    const response = await fetch(`${optionsApiUrl}/${endpoint}`, { 
      method: "GET", 
      headers: headers
    });
    
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
}

export async function postToOptionsApi(endpoint, data) {
  try {
    // Get Options API token from session storage 
    const token = sessionStorage
      .getItem("optionsApiToken") // Changed to use the optionsApiToken
      .substring(1, sessionStorage.getItem("optionsApiToken").length - 1);
    
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    };
    
    const response = await fetch(
      `${optionsApiUrl}${endpoint}`, 
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data)
      }
    );
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
}

// Add helper methods for PUT and DELETE if needed
export async function putToOptionsApi(endpoint, data) {
  try {
    const token = sessionStorage
      .getItem("optionsApiToken")
      .substring(1, sessionStorage.getItem("optionsApiToken").length - 1);
    
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    };
    
    const response = await fetch(
      `${optionsApiUrl}${endpoint}`, 
      {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(data)
      }
    );
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
}

export async function deleteFromOptionsApi(endpoint) {
  try {
    const token = sessionStorage
      .getItem("optionsApiToken")
      .substring(1, sessionStorage.getItem("optionsApiToken").length - 1);
    
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    };
    
    const response = await fetch(
      `${optionsApiUrl}${endpoint}`, 
      {
        method: "DELETE",
        headers: headers
      }
    );
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
}

// Example usage functions - unchanged
export const optionsApi = {
  getWeatherForecast: () => fetchFromOptionsApi('WeatherForecast'),
  getEmployeeOptions: () => fetchFromOptionsApi('EmployeeOptions'),
  updateEmployeeOption: (id, data) => postToOptionsApi(`EmployeeOptions/${id}`, data),
  // Add more methods as needed
};